hideShopDropdown();
hideLearnDropdown();
checkForRecharge();
hideMobileMenu();
checkForContact();

$('body').append($('<script async type="text/javascript" src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=VkMD7p"></script>'));

$('body').removeClass('overflow-hidden');

// PRODUCT SWIPERS

const thumbnailSwiper = new Swiper('.thumbnails-swiper', {
	// Optional parameters
	direction: 'horizontal',
	loop: false,
	slidesPerView: 7.5,
	spaceBetween: 10,
	freeMode: true,
	// If we need pagination
	pagination: {
		el: '.swiper-pagination',
	},

	// And if we need scrollbar
	scrollbar: {
		el: '.swiper-scrollbar',
	},
});

const productSwiper = new Swiper('.product-swiper', {
	// Optional parameters
	direction: 'horizontal',
	loop: false,
	thumbs: {
		swiper: thumbnailSwiper,
	},
	// If we need pagination
	pagination: {
		el: '.swiper-pagination',
	},
	zoom: true,
	// Navigation arrows
	navigation: {
		nextEl: '.product-next',
		prevEl: '.product-prev',
	},

	// And if we need scrollbar
	scrollbar: {
		el: '.swiper-scrollbar',
	},
});

const partnerSwiper = new Swiper('.partner-swiper', {
	// Optional parameters
	direction: 'horizontal',
	loop: true,
	slidesPerView: 3,
	autoplay: {
		delay: 2000,
	},
	spaceBetween: 30,
	centeredSlides: true,
	disableOnInteraction: false,
	breakpoints: {
		700: {
			slidesPerView: 6,
			spaceBetween: 50,
		},
	},
});

$('.variant-selector').on('change', function() {
	location.href = $(this).val();
});

$('.quick-add').click(function() {
	let id = $(this).val();
	let item = {
		id: id,
		quantity: 1,
	};
	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'xmlhttprequest',
		},
		body: JSON.stringify(item),
	})
		.then(data => {
			$(this).text('Added!');
			setTimeout(() => {
				$(this).text('+ Quick Add');
			}, 1000);
		})
		.catch(error => console.log('ERROR'));
});

$('summary').click(function() {
	$(this)
		.find('.faq-caret')
		.toggleClass('-rotate-90');
});

$('.open-mobile-menu').click(function() {
	showMobileMenu();
	$('body').addClass('overflow-hidden');
});
$('.close-mobile-menu').click(function() {
	hideMobileMenu();
	$('body').removeClass('overflow-hidden');
});

$('body').on('click', '.trash', function() {
	event.preventDefault();
	nearKey = $(this).val();
	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		data: {
			quantity: 0,
			id: nearKey,
		},
		dataType: 'json',
		success: function(event) {
			refreshTempCart();
			refreshCart();
		},
		failed: function() {
			console.log('Item Not Removed!');
		},
	});
});

$('body').on('click', '.onemore', function() {
	event.preventDefault();
	let nearKey = $(this).val();
	let tempquan = $(this).data('quantity');
	console.log(tempquan);
	tempquan = tempquan + 1;
	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		data: {
			quantity: tempquan,
			id: nearKey,
		},
		dataType: 'json',
		success: function(event) {
			refreshCart();
		},
		failed: function() {
			console.log('Item Not Removed!');
		},
	});
});

$('body').on('click', '.oneless', function() {
	event.preventDefault();
	let nearKey = $(this).val();
	let tempquan = $(this).data('quantity');
	console.log(tempquan);
	tempquan = tempquan - 1;
	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		data: {
			quantity: tempquan,
			id: nearKey,
		},
		dataType: 'json',
		success: function(event) {
			refreshCart();
		},
		failed: function() {
			console.log('Item Not Removed!');
		},
	});
});

$('#shop-all-menu-links')
	.find('a')
	.click(() => showShopAll());
$('.header-link').click(() => {
	$('#shop-all-menu').addClass('shop-all-hidden');
	$('body').removeClass('overflow-hidden');
});

async function showForgotPW() {
	event.preventDefault();
	$('.login-form').addClass('hidden');
	$('.forgot-password-form').removeClass('hidden');
}

async function iRememberPW() {
	event.preventDefault();
	$('.login-form').removeClass('hidden');
	$('.forgot-password-form').addClass('hidden');
}

async function checkForRecharge() {
	let loc = await getPageUrl();
	let pattern = '/tools/recurring/login';

	if (loc.indexOf(pattern) !== -1) {
		console.log('Reload');
		window.location.href = '/tools/recurring/login#';
	}
}

async function checkForContact() {
	let loc = await getPageUrl();
	let pattern = 'contact';

	if (loc.indexOf(pattern) !== -1) {
		console.log("You're on the contact page...");
		hideAllNonShippingFAQ();
		setTimeout(() => {
			$('.shipping-trigger').removeClass('bg-gray-500');
			$('.shipping-trigger').addClass('bg-black');
		}, 500);
	}
}

function showShopDropdown() {
	$('#dropdown-shop').removeClass('-translate-y-[100vh]');
	$('#dropdown-learn').addClass('-translate-y-[100vh]');
}

function hideShopDropdown() {
	$('#dropdown-shop').addClass('-translate-y-[100vh]');
}

function showLearnDropdown() {
	$('#dropdown-learn').removeClass('-translate-y-[100vh]');
	$('#dropdown-shop').addClass('-translate-y-[100vh]');
}

function hideLearnDropdown() {
	$('#dropdown-learn').addClass('-translate-y-[100vh]');
}

// function checkForGorgiasForm() {
// 	let pageContainsGF = document.querySelector('div[gorgias-contact-form-wrapper]');
// 	if (!pageContainsGF) return;
// 		console.log("Gorgias Now On");
// 		console.log('Gorgias Page.');
// }

function showShopAll() {
	$('#shop-all-menu').toggleClass('shop-all-hidden', 1000, 'easeOutSine');
	$('body').toggleClass('overflow-hidden');
}

$('.show-shop-all').click(function() {
	showShopAll();
});

async function getPageUrl() {
	const pageUrl = $(location).attr('href');
	return pageUrl;
}

async function addToCart(id) {
	let sellingPlan = $('.atc').data('sellingplan');
	let item = {
		id: id,
		quantity: 1,
		selling_plan: sellingPlan,
	};
	console.log(sellingPlan);
	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'xmlhttprequest',
		},
		body: JSON.stringify(item),
	})
		.then(data => {
			window.location.href = '/cart';
		})
		.catch(error => console.log('ERROR'));
}
function buyNow(id) {
	let sellingPlan = $('.bnb').data('sellingplan');
	let item = {
		id: id,
		quantity: 1,
		selling_plan: sellingPlan,
	};
	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'xmlhttprequest',
		},
		body: JSON.stringify(item),
	})
		.then(data => {
			window.location.href = '/checkout';
		})
		.catch(error => console.log('ERROR'));
}
function refreshTempCart() {
	$('.cart-items-wrapper').load(document.URL + ' .cart-items');
	$('#cart-count-wrapper').load(document.URL + ' #cart-count');
	console.log('Temp Cart Refreshed');
}

function refreshCart() {
	$('.cart-items-wrapper').load(document.URL + ' .cart-items');
	$('#cart-count-wrapper').load(document.URL + ' #cart-count');
	$('#cart-price-wrapper').load(document.URL + ' #cart-price');
	$('#free-shipping-wrapper').load(document.URL + ' #free-shipping-info');
	console.log('Cart Refreshed');
}

function clearCart(id) {
	fetch('/cart/clear.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'xmlhttprequest',
		},
		body: '',
	})
		.then(data => {
			refreshTempCart();
		})
		.catch(error => console.log('ERROR'));
}

function showMobileMenu() {
	$('#mobile-menu').removeClass('hidden-menu');
}
function hideMobileMenu() {
	$('#mobile-menu').addClass('hidden-menu');
}

// no init needed
async function scrollToTop() {
	document.body.scrollTop = 0; // For Safari
	document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

async function filterFaqByCategory(category) {
	$('.faqs-triggers > *').removeClass('bg-black');
	$('.faqs-triggers > *').addClass('bg-gray-500');
	$(event.target).removeClass('bg-gray-500');
	$(event.target).addClass('bg-black');
	// Loop through all elements with class "faq"
	$('.faq').each(function() {
		// Get the value of the "cat" data-attribute
		var cat = $(this).data('cat');

		// Check if the "cat" data-attribute matches the specified category
		if (cat === category) {
			// If it does match, remove the "hidden" class if it exists
			$(this).removeClass('hidden');
		} else {
			// If it does not match, add the "hidden" class if it is not already present
			if (!$(this).hasClass('hidden')) {
				$(this).addClass('hidden');
			}
		}
	});
}

function hideAllNonShippingFAQ() {
	let category = 'shipping';
	$('.faqs-triggers > *').removeClass('bg-black');
	$('.faqs-triggers > *').addClass('bg-gray-500');
	// Loop through all elements with class "faq"
	$('.faq').each(function() {
		// Get the value of the "cat" data-attribute
		var cat = $(this).data('cat');

		// Check if the "cat" data-attribute matches the specified category
		if (cat === category) {
			// If it does match, remove the "hidden" class if it exists
			$(this).removeClass('hidden');
		} else {
			// If it does not match, add the "hidden" class if it is not already present
			if (!$(this).hasClass('hidden')) {
				$(this).addClass('hidden');
			}
		}
	});
}

$sasButton = $('.sas-button');
$sasButtonDot = $('.sas-button > .dot');

$sasButton.click(function() {
	$sasButton.removeClass('selected');
	$sasButtonDot.addClass('selected');
	$(this).addClass('selected');

	let val = $(this).attr('value');
	console.log(val);
	$('.atc').data('sellingplan', val);
	$('.bnb').data('sellingplan', val);

	let productId = $('.product-id').val();
	let productPrice = $('.product-price').val();
	let productNormal = (productPrice / 100).toFixed(2);
	let productDiscount = ((productPrice - productPrice * 0.1) / 100).toFixed(2);

	if ($(this).hasClass('otp')) {
		$('#product-price').text(`$${productNormal}`);
	} else {
		$('#product-price').text(`$${productDiscount}`);
	}
});
